import React, { memo, useCallback } from "react";
import { TableData } from "../tableContext/TableContext";
import TableItem from "./TableItem";
import TableItemExtra from "../TableItemExtra";

function TableRows({
  tableData,
  ActionButtonsComponent,
}: {
  tableData: TableData[];
  ActionButtonsComponent?: any;
}) {
  const getActionButtonsComponent = useCallback(
    (props: any) => {
      if (!ActionButtonsComponent) return null;
      return <ActionButtonsComponent {...props} />;
    },
    [ActionButtonsComponent],
  );

  return (
    <>
      {tableData.map(
        (
          { id, data, rowClassName, crudData, extraData, extraDataPreset },
          rowIndex,
        ) => (
          <React.Fragment key={`${id}-${rowIndex}`}>
            <TableItem
              tableItemId={id}
              crudData={crudData}
              tableItemData={data}
              rowClassName={rowClassName}
              ActionButtonsComponent={
                ActionButtonsComponent ? getActionButtonsComponent : undefined
              }
            />
            {extraData?.map((extraDataItem, index) => (
              <TableItemExtra
                extraData={extraDataItem}
                extraDataPreset={extraDataPreset}
                extraDataRowIndex={index}
                extraDataRowsCount={extraData.length}
                key={index}
              />
            ))}
          </React.Fragment>
        ),
      )}
    </>
  );
}

export default memo(TableRows);
